/* eslint-disable */
import classNames from 'classnames';
import React from 'react';
import { UI_NAME } from '../../../../utils/config';
import { marginClasses, paddingClasses } from '../../../../utils/styles';
import PropTypes from 'prop-types';

const DropdownFooter = ({ children, className, ...props }) => {
  const classes = classNames(`${UI_NAME}-dropdown__footer`,
    ...marginClasses(props),
    ...paddingClasses(props),
    className);

  return (
    <div className={classes}>
      {children}
    </div>
  )
}

DropdownFooter.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}

export default DropdownFooter;
